import { getFunctions, httpsCallable } from 'firebase/functions';

export { atlasErrorMessage } from './atlasErrors';

const fns = () => getFunctions(undefined, 'us-central1');

function callable<Req extends object, Res>(name: string) {
  return httpsCallable<Req, Res>(fns(), name);
}

export interface AtlasRepoProbe {
  repo: string;
  ok: boolean;
  private: boolean | null;
  defaultBranch: string | null;
  htmlUrl: string | null;
  hasSkills: boolean;
  skillCount: number;
  message: string;
}

export async function getAtlasConnection(): Promise<{
  repo: string | null;
  source: 'crm' | 'env' | 'default' | null;
  canEdit: boolean;
  hasGithubToken?: boolean;
  githubTokenHint?: string | null;
  githubTokenSource?: 'crm' | 'env' | null;
  probe: AtlasRepoProbe | null;
}> {
  const fn = callable<
    object,
    {
      repo: string | null;
      source: 'crm' | 'env' | 'default' | null;
      canEdit: boolean;
      hasGithubToken?: boolean;
      githubTokenHint?: string | null;
      githubTokenSource?: 'crm' | 'env' | null;
      probe: AtlasRepoProbe | null;
    }
  >('getAtlasConnection');
  const res = await fn({});
  return res.data;
}

export async function probeAtlasRepo(repo: string, token?: string): Promise<AtlasRepoProbe> {
  const fn = callable<{ repo: string; token?: string }, AtlasRepoProbe>('probeAtlasRepo');
  const res = await fn({ repo, ...(token ? { token } : {}) });
  return res.data;
}

export async function saveAtlasRepo(
  repo: string,
  token?: string,
): Promise<{ repo: string; probe: AtlasRepoProbe; hasGithubToken?: boolean; githubTokenHint?: string }> {
  const fn = callable<
    { repo: string; token?: string },
    { repo: string; probe: AtlasRepoProbe; hasGithubToken?: boolean; githubTokenHint?: string }
  >('saveAtlasRepo');
  const res = await fn({ repo, ...(token ? { token } : {}) });
  return res.data;
}
